// src/app/views/pages_admin/exam_imp/examImp-routes.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const ExamImp = Loadable(lazy(() => import("./ExamImp")));

const routes = Object.values(EXAM_TYPES).map(examType => ({
  path: `${examType.pathPrefix}/exam-imp`,
  element: <ExamImp />
}));

export default routes;
